import {
  ArrayParam,
  BooleanParam,
  NumericArrayParam,
  StringParam,
  useQueryParam,
  withDefault,
} from 'use-query-params';

const useListParams = () => {
  const [q, setQ] = useQueryParam('q', withDefault(StringParam, undefined));
  const [status, setStatus] = useQueryParam(
    'status',
    withDefault(StringParam, undefined)
  );
  const [apps, setApps] = useQueryParam(
    'apps',
    withDefault(ArrayParam, undefined)
  );

  const [packs, setPacks] = useQueryParam(
    'pack',
    withDefault(NumericArrayParam, [])
  );
  const [orderBy, setOrderBy] = useQueryParam(
    'order_by',
    withDefault(StringParam, 'created')
  );
  const [desc, setDesc] = useQueryParam(
    'desc',
    withDefault(BooleanParam, true)
  );
  const [date, setDate] = useQueryParam(
    'date',
    withDefault(StringParam, undefined)
  );

  return {
    q,
    setQ,
    packs,
    setPacks,
    apps,
    setApps,
    status,
    setStatus,
    date,
    setDate,
    orderBy,
    setOrderBy,
    desc,
    setDesc,
  };
};

export default useListParams;
